// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Id","innerTile":"Jd","heading":"Kd","instaTileBtn":"Ld","disabled":"Md","instaTileElement":"Nd","instagramPic":"Od"};